import {LOG_OUT} from "./ActionTypes";

import AgencyPerformanceService from "../services/AgencyPerformanceService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});


export const getPerformanceScores = (locationId, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = {};
            let user = getUser();
            if (user.role.access_level === 1 && allLocation) {
                result = await AgencyPerformanceService.getCombinedPerformanceScores();
            } else {
                result = await AgencyPerformanceService.getPerformanceScores(locationId);
            }

            if (user['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getCombinedPerformanceScores = () => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getCombinedPerformanceScores();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getLocationCount = () => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getLocationCount();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);


export const getIndividualPerformanceData = (userId) => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getIndividualPerformanceData(userId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDepartmentInfo = (userId) => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getDepartmentInfo(userId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDashboardUserList = () => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getUserList();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data.user;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getCompensationList = (userId) => (
    async (dispatch) => {
        try {
            const compensationListData = await AgencyPerformanceService.compensationList(userId);

            if (getUser()['app-version'] !== compensationListData.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === compensationListData.status) {
                return compensationListData.data.compensation_profile;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const staffRevenues = (compProfileId, revenues, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await AgencyPerformanceService.getStaffRevenues(compProfileId);
            } else {
                result = await AgencyPerformanceService.updateStaffRevenues(compProfileId, revenues);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getAgencyTotalRevenue = (plProfileId) => (
    async (dispatch) => {
        try {
            let result = await AgencyPerformanceService.getAgencyTotalRevenues(plProfileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/AgencyPerformanceAction.js